export const communicationBannerTestIds = {
    root: 'CommunicationBanner',
    view: 'CommunicationBanner.View',
    text: 'CommunicationBanner.Text',
    close: 'CommunicationBanner.View.CloseButton',
} as const;

export const communicationModalTestIds = {
    root: 'CommunicationModal',
    action: 'CommunicationModal.Action',
    close: 'YaKitModal.CommunicationModal.CloseButton',
} as const;
